import React, {useState, useEffect} from 'react'
import Layout from '../../components/Layout/Layout'
import axios from 'axios'
import toast from 'react-hot-toast';
import { Link } from 'react-router-dom';
import { FaTrashAlt,FaPencilAlt  } from "react-icons/fa";
import { SERVER_API } from '../../fileWithConstants';
import { AutoComplete } from 'rsuite';

const CategoryList = () => {
  const [searchcat, setSearchcat] = useState('');
  const [categories, setCategories] = useState([]);
  const getFabricCategoryData = async()=>{
    try {
      const {data} = await axios.get(`${SERVER_API}/api/v1/fabric/get-fabric-category`);
      if(data?.success && data?.category.length>0){
        setCategories(data?.category);
      }else{
        toast.error('Some thing went wrong while getting fabric data.')
      }
    } catch (error) {
      console.log(error)
    }
  }

  const searchCategoryfilter = async(searchcat)=>{
    try {
      if(searchcat!==''){
        console.log(searchcat);
        setSearchcat(searchcat)
        const {data} = await axios.get(`${SERVER_API}/api/v1/fabric/get-fabric-category/${searchcat}`);
        if(data?.success && data?.category.length>0){
          setCategories(data?.category);
        }
      }else{
        setSearchcat('');
        getFabricCategoryData();
      }
     } catch (error) {
       console.log(error)
     }
  }

  const deleteCategory = async(id)=>{
    try {
     const answer = window.confirm('Are you sure, you want to delete this?');
      if(!answer) return;
      const {data} = await axios.delete(`${SERVER_API}/api/v1/fabric/delete-fabric-category/${id}`);
      if(data?.success){
        toast.success('Category deleted successfully.')
        getFabricCategoryData();
      }
    } catch (error) {
      console.log(error)
    }
     
    }

useEffect(()=>{
  getFabricCategoryData();
},[]);

  return (
    <Layout title={'Fabric Category List'}>
        <div className='container'>
            <div className='row justify-content-center'>
            <h1 className='page-title float-start col-md-12' >Fabric Category</h1> 
             
              
            <div class="row justify-content-center">
            <div class="col-md-12 custom-inline-form">
              <div className='form-box btn-box'><Link to={'/dashboard/add-category'} className='btn btn-primary float-end'>+ Add Category</Link></div>
            
              <div className='form-box big-box'>
              <input type="text" className="form-control" value={searchcat} name='searchcat' onChange={(e)=>searchCategoryfilter(e.target.value)} placeholder='Search by name' required />
              </div>
              </div>
              </div>

                <div className='table-box col-md-4'>
                  <table className="table table-responsive table-hover table-sticky">
                    <thead>
                      <tr className='align-item'>
                        <th scope="col" style={{width: "60px"}}>#</th>
                        <th scope="col" className='text-start'>Name</th>
                        <th scope="col" style={{width: "150px"}}>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                          {categories?.map((cat, index)=>(
                            <tr key={index}>
                              <td>{index+1}</td>
                              <td className='text-start'>
                              {cat.name}       
                              </td>   
                              <td className='action-td'>
                                <Link to={`/dashboard/update-category/${cat.id}`} className='text-primary' title="Edit Category"><FaPencilAlt/></Link>
                                <div className='action-box' style={{display:"none"}}>
                                  <Link to='#' onClick={()=>deleteCategory(cat.id)} className='text-danger'><FaTrashAlt /></Link>
                                </div>
                              </td>
                            </tr>
                          ))}
                      </tbody>
                  </table>
                </div>
             
            </div>
        </div>
    </Layout>
  )
}

export default CategoryList
